import {AttributesState} from '.';
import { GetterTree } from 'vuex';
import { AppState } from '../app';
import {ContactAttributeViewModel} from '@/messaging/models/contactAttributeViewModel';

export const getters: GetterTree<AttributesState, AppState> = {


	allContactAttributes(state: AttributesState): ContactAttributeViewModel[] {
		return state.contactAttributes;
	},

	contactAttributes(state: AttributesState): ContactAttributeViewModel[] {
		return state.contactAttributes.filter(a => !a.archived);
	},

	getAttribute(state: AttributesState): (attributeId: string) => ContactAttributeViewModel | undefined {
		return (attributeId: string) => {
			return state.contactAttributes.find(attr => attr.id === attributeId);
		};
	},

	isAttributeArchived(state: AttributesState): (attributeId: string) => boolean {
		return (attributeId: string) => {
			const attribute = state.contactAttributes.find(attr => attr.id === attributeId);
			return !!attribute && attribute.archived;
		};
	},

	doesAttributeExist(state: AttributesState) {
		return (attributeId: string) => {
			return !!state.contactAttributes.find(attr => attr.id === attributeId);
		};
	},
};
